import React from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import HomeBk from "../img/home_background.jpg";

//navigation
import HomeMenu from "../navigation/HomeMenu";

export default function HomePage () {
    
    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+HomeBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"20px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>

            <HomeMenu/>
        </div>
    );
}